import { render } from "./TokenInput.vue?vue&type=template&id=2cb6d83c&scoped=true"
import script from "./TokenInput.vue?vue&type=script&lang=js"
export * from "./TokenInput.vue?vue&type=script&lang=js"

import "./TokenInput.vue?vue&type=style&index=0&id=2cb6d83c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb6d83c"]])

export default __exports__